import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((cfg) => {
    const token = localStorage.getItem("kabir_admin_token");
    if (token) cfg.headers.Authorization = `Bearer ${token}`;
    return cfg;
});

export default client;
